'use client';

import { cn } from '@/lib/utils';

export interface Frame {
  order?: number;
  title?: string;
  description?: string;
  emotion?: string;
  imageUrl?: string;
  visualSuggestion?: string;
}

interface FrameGridProps {
  frames: Frame[];
  className?: string;
}

/** Visual frame card grid for storyboards */
export function FrameGrid({ frames, className }: FrameGridProps) {
  if (!frames || frames.length === 0) return null;

  return (
    <div className={cn('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4', className)}>
      {frames.map((frame, index) => (
        <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-brand-primary to-purple-500 px-4 py-2">
            <div className="flex items-center justify-between">
              <span className="text-white font-semibold text-sm">
                Frame {frame.order || index + 1}
              </span>
              {frame.emotion && (
                <span className="px-2 py-0.5 bg-white/20 text-white rounded-full text-xs">
                  {frame.emotion}
                </span>
              )}
            </div>
          </div>
          <div className="p-4">
            {frame.title && <h4 className="font-medium text-gray-900 mb-2">{frame.title}</h4>}
            {frame.description && <p className="text-gray-600 text-sm leading-relaxed">{frame.description}</p>}
            {frame.visualSuggestion && (
              <p className="text-xs text-purple-600 mt-2 italic">Visual: {frame.visualSuggestion}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
